import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ChatFeedService {
    /**
     * Subject to let components know an item in the chat feed has been updated or a new item has been created
     */
    public readonly chatFeedChanged = new Subject<void>();

    /**
     * Tracks the currently selected chat feed item
     */
    public readonly selectedChatId$ = new BehaviorSubject<string | undefined>(undefined);

}
